export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ReadOnlyField.vue?vue&type=style&index=0&id=2d22e418&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ReadOnlyField.vue?vue&type=style&index=0&id=2d22e418&prod&scoped=true&lang=css&
// module id = 1587
// module chunks = 0